<template>
    <div>
        <CustomSelect
            v-bind="$props"
            :itemComponent="component"
            search
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
import CustomSelect from './Select';

export default {
    props: {
        ...CustomSelect.props,
    },
    data() {
        return {
            component: () => import('./SelectItemTag'),
        };
    },
    components: {
        CustomSelect,
    },
};
</script>

<style lang="scss"></style>
